
import instance_api from "../../config/axiosConfig";
import { getWorkLocations,confirmVTORequest, getVTOOfferDetail,getVTORequestsBatch,getVTOOfferByEmp,submitVTONewRequest,getVTOOffersBatch, getVTOOffer,submitVTOOffer, getSickBalance, getVTORequestsAdminBundle, updateSlots, updateOfferStatus, postReqResolution, getChangeLog, getVTOStationList, submitEditCutOff, vtoForecast, vtoForecastIntervals, departmentServices,vtoPotentialSavings } from '../../../src/constants/constants';


class VTOAPI  {
    
    constructor(name) {
        this.name = name;
      }
    
    getWorkLoc(station=''){
        return instance_api('GET', getWorkLocations(station));
    }

    getOffersData(data) {
        return instance_api('POST', getVTOOffersBatch(), data);
    }

    getOfferDetailedData(data) {
        return instance_api('GET', getVTOOfferDetail(data));
    }

    submitOffersBatch(data) {
        return instance_api('POST', submitVTOOffer(), data);
    }

    submitRequest(data) {
        return instance_api('POST', submitVTONewRequest(), data);
    }

    getEmployeeRequests(data) {
        return instance_api("POST", getVTORequestsBatch(), data);
    }

    getEmployeeShift(empId='', station='', shiftStartDate='', shiftEndDate='' ) {
        return instance_api("GET", getSickBalance(empId, station, shiftStartDate, shiftEndDate))
    }

    getRequestsAdminBundle(data) {
        return instance_api("POST", getVTORequestsAdminBundle(), data);
    }

    submitConfirmRequest(data) {
        return instance_api("POST", confirmVTORequest(), data);
    }

    updateSlotsReq(offerId='', station='', slots='') {
         const data = {
            offerId,
            station,
            slots}
        return instance_api("PUT", updateSlots(), data);
    }

    updateOfferStatusReq(offerId='', station='', status='') {
         const data = {
            offerId,
            station,
            status}
        return instance_api("PUT", updateOfferStatus(), data);
    }
    
    submitReqResolution(offerId='', employeeId='', workbrainRequestId='', resolveAction='', resolveComments='') {
         const data = {
            offerId,
            employeeId,
            workbrainRequestId,
            resolveAction,
            resolveComments
        }
        return instance_api("POST", postReqResolution(), data);
    }

    getChangeLogVTO(offerId='') {
        return instance_api("GET", getChangeLog(offerId));
    }

    getStationListVTO(offerId='') {
        return instance_api("GET", getVTOStationList(offerId));
    }

    submitEditCutOffData (offerId='', station='', cutoffTime='', untilDepleted=false) {
        const data = {
            offerId,
            station,
            cutoffTime,
            untilDepleted
        }
        return instance_api("PUT", submitEditCutOff(), data);
    }

    getVtoForecast(station='', department='', startDate='', timeFrame='', roleType='', workLocations='') {
        return instance_api("GET", vtoForecast(station, department, startDate, workLocations,roleType, timeFrame));
    }

    getVtoForecastIntervals(station='', department='', startDate='', timeFrame='', roleType='', workLocations='') {
        return instance_api("GET", vtoForecastIntervals(station, department, startDate, workLocations,roleType, timeFrame));
    }
    //home page index file needs to be created. move this api call there later
    getDepartmentServices(station='') {
        return instance_api("GET", departmentServices(station));
    }
    // new method for potential savings
    getVtoPotentialSavings(station='', date='', department='') {
        return instance_api("GET", vtoPotentialSavings(station, date, department));
    }
}

export const {
    getWorkLoc,
    getOffersData,
    getOfferDetailedData,
    submitRequest,
    getEmployeeRequests,
    getEmployeeShift,
    getRequestsAdminBundle,
    submitOffersBatch,
    submitConfirmRequest,
    updateSlotsReq,
    updateOfferStatusReq,
    submitReqResolution,
    getChangeLogVTO,
    getStationListVTO,
    submitEditCutOffData,
    getVtoForecast,
    getVtoForecastIntervals,
    getDepartmentServices,
    getVtoPotentialSavings
} = new VTOAPI("instance");
